import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext, useMemo } from 'react';
import { useStore } from 'zustand';
import { createTableListStore, DEFAULT_TABLE_LIST_CONFIG } from './TableListStore';
export const actionColumnDef = {
    width: 40
};
export const expandIconStyle = {
    width: 24
};
const DEFAULT_CONTEXT_HANDLE = {
    store: createTableListStore({
        config: DEFAULT_TABLE_LIST_CONFIG,
        expandedRows: {},
        selectedRows: {},
        numRows: 0,
        numSelectedRows: 0,
        onToggleAllSelection: ()=>{}
    }),
    actions: {
        toggleExpandedRow: ()=>{},
        setSelectedRows: ()=>{},
        setSort: ()=>{},
        expandAllRows: ()=>{},
        registerRow: ()=>{},
        unregisterRow: ()=>{}
    }
};
export const TableListContext = React.createContext(DEFAULT_CONTEXT_HANDLE);
export const useTableListSelector = (selector)=>{
    const { store } = useContext(TableListContext);
    return useStore(store, selector);
};
export const useTableListActions = ()=>useContext(TableListContext).actions;
export const useTableListContext = ()=>{
    const { store, actions } = useContext(TableListContext);
    const state = useStore(store);
    return useMemo(()=>_object_spread(_object_spread_props(_object_spread({}, state.config), {
            expandedRows: state.expandedRows,
            selectedRows: state.selectedRows,
            sort: state.sort,
            numRows: state.numRows,
            numSelectedRows: state.numSelectedRows,
            onToggleAllSelection: state.onToggleAllSelection
        }), actions), [
        state,
        actions
    ]);
};
